<form [formGroup]="companyForm" (ngSubmit)="onSubmit()" class="mt-4">
  <div class="company-form p-3 border rounded">
    <h4>Informations sur la société</h4>

    <!-- Bouton pour charger l'adresse utilisateur -->
    <div class="d-flex justify-content-end mb-3">
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="useUserAddress()">
        <i class="bi bi-person-pin"></i> Utiliser mon adresse
      </button>
    </div>

    <!-- Nom -->
    <mat-form-field appearance="outline" class="w-100 mb-3">
      <mat-label>Nom de la société</mat-label>
      <input matInput formControlName="companyName" />
    </mat-form-field>

    <!-- Numéro -->
    <mat-form-field appearance="outline" class="w-100 mb-3">
      <mat-label>Numéro d’entreprise (ex: BE0123456789)</mat-label>
      <input matInput formControlName="companyNumber" />
      @if(companyForm.get('company.companyNumber')?.hasError('invalidTva')){
        <mat-error>
            {{ companyForm.get('company.companyNumber')?.getError('invalidTva') }}
        </mat-error>
      }
      @if(companyForm.get('company.companyNumber')?.hasError('tvaError')){
        <mat-error>
            {{ companyForm.get('company.companyNumber')?.getError('tvaError') }}
        </mat-error>
      }
    </mat-form-field>

    <!-- Role -->
    <mat-form-field appearance="outline" class="w-100 mb-3">
      <mat-label>Votre rôle dans l'entreprise</mat-label>
      <input matInput formControlName="roleInCompany" />
    </mat-form-field>

    <!-- Email -->
    <mat-form-field appearance="outline" class="w-100 mb-3">
      <mat-label>Email de la société</mat-label>
      <input matInput type="email" formControlName="companyEmail" />
    </mat-form-field>

    <!-- Téléphone -->
    <mat-form-field appearance="outline" class="w-100 mb-3">
      <mat-label>Téléphone de la société</mat-label>
      <input matInput formControlName="companyPhoneNumber" />
    </mat-form-field>

    <!-- Adresse -->
    <fieldset formGroupName="address" class="mt-3">
      <legend>Adresse de la société</legend>
        <div class="row">
          <div class="mb-3">                
              <input type="text" id="address" [formControl]="addressCtrl" class="form-control">
              @if(suggestions.length){
                <ul class="list-group mt-1">
                  @for( s of suggestions; track $index ){
                    <li class="list-group-item selectSuggestion" (click)="selectSuggestion(s)">
                    {{ s.place_name }}
                    </li>
                  }
                </ul>
              }
          </div>
        </div>
    </fieldset>

    <!-- Catégorie -->
    <mat-form-field appearance="outline" class="w-100 mb-3">
      <mat-label>Catégorie</mat-label>
      <mat-select formControlName="category">
        @for(cat of categories; track $index){
            <mat-option [value]="cat">{{ cat }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <!-- Description -->
    <mat-form-field appearance="outline" class="w-100 mb-3">
      <mat-label>Description (optionnel)</mat-label>
      <textarea matInput formControlName="description"></textarea>
    </mat-form-field>

    <!-- Submit or Cancel -->
    <div class="d-flex justify-content-center gap-3 mt-4">
      <button type="submit" class="btn btn-primary">
        <i class="bi bi-plus-circle me-1"></i> Ajouter la société
      </button>
      <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">
        <i class="bi bi-x-circle me-1"></i> Annuler
      </button>
    </div>
  </div>
</form>
